import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Default permissions: when user is admin or no group assigned, allow everything
const DEFAULT_PERMISSIONS = {
  view_simulator: true,
  view_admin: true,
  view_net_salary: true,
  view_company_cost: true,
  view_margin: true,
  view_business_decision: true,
  view_premium: true,
  view_annual_view: true,
  view_proposals: true,
  view_candidates: true,
  view_history: true,
  edit_simulator_overrides: true,
  export_pdf: true,
};

/**
 * Returns the permission map for the current user.
 * Admins get everything by default; non-admin users get their group's permissions.
 */
export const usePermissions = (getAuthHeaders, user) => {
  const [permissions, setPermissions] = useState(DEFAULT_PERMISSIONS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      // Admin: full access without round-trip
      if (!user || user.role === "admin") {
        if (!cancelled) {
          setPermissions(DEFAULT_PERMISSIONS);
          setLoading(false);
        }
        return;
      }
      try {
        const r = await axios.get(`${API}/me/permissions`, { headers: getAuthHeaders() });
        if (!cancelled) {
          setPermissions({ ...DEFAULT_PERMISSIONS, ...(r.data?.permissions || {}) });
        }
      } catch (e) {
        if (!cancelled) setPermissions(DEFAULT_PERMISSIONS);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const can = (key) => permissions[key] !== false; // default-allow if missing
  return { permissions, loading, can };
};
